

export const formatPhoneNo = (pno: string | null | undefined): string => {
    if (pno) {
        return pno.replace(/\((\d{3})\)(\d{3})-(\d{3})/, '$1$2$3')
    } else {
        return ''
    }
}

export const formatPhoneNoInReadableForm = (pno: string | null | undefined, locale: string): string => {
    if (pno && (locale === 'en-us' || locale === 'en-ca')) {
        return pno.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    } else {
        return pno;
    }
}

export const sanitizePhoneNo = (pno: string | null | undefined): string => {
    if (pno) {
        return pno.match(/\d+/g).join('')
    } else {
        return '';
    }

}

/**
 * Checks if a JWT token is expired
 * @param token - The JWT token string
 * @returns true if token is expired or invalid, false if token is valid and not expired
 */
export const isJwtTokenExpired = (token: string | null | undefined): boolean => {
    if (!token) {
        return false; // No token is not considered expired, just missing
    }

    try {
        // JWT tokens have three parts separated by dots: header.payload.signature
        const parts = token.split('.');
        if (parts.length !== 3) {
            return true; // Invalid token format
        }

        // Decode the payload (second part)
        const payload = parts[1];
        // Base64 decode and parse the payload
        const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));

        // Check if the token has an expiration claim (exp)
        if (!decodedPayload.exp) {
            // If there's no expiration claim, we can't determine if it's expired
            // For safety, treat it as potentially expired
            return true;
        }

        // exp is in seconds since epoch, convert to milliseconds and compare with current time
        const expirationTime = decodedPayload.exp * 1000;
        const currentTime = Date.now();

        // Add a small buffer (5 seconds) to account for clock skew
        return currentTime >= (expirationTime - 5000);
    } catch (error) {
        console.error('Error checking JWT token expiration:', error);
        // If we can't parse the token, treat it as expired/invalid
        return true;
    }
}

export interface CartCompanyNameSource {
    taxExemption?: { companyName?: string | null; vatNo?: string | null } | null;
    billingAddress?: { companyName?: string | null } | null;
}

export const resolveCompanyNameFromCart = (cart: CartCompanyNameSource): string =>
    cart.taxExemption?.companyName?.trim() ||
    cart.billingAddress?.companyName?.trim() ||
    '';